import React, { Component } from 'react';
import $ from 'jquery'; 
import Filter from './ctn/eBay/Filter.js'
import ItemsTable from './ctn/eBay/ItemsTable.js'
import Pagination from './ctn/eBay/Pagination.js'
import Modal from './ctn/eBay/Modal.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import {ajaxPerso} from "../fnc.js"

const refConst = require("../constants.js").v

class Ebay extends Component {
	constructor(props) {
		super(props);

		this.fncModalAccept = {fnc: () => {}, name: 'yes'}
		this.fncModalRefuse = {fnc: () => {}, name: 'no'}
		this.fncModalExit = () => {}
		
		this.policyShippingIdModal = null
		this.policyPayementgIdModal = null
		this.policyReturnIdModal = null

		this.state = {
			shippingSelected: null,
			payementSelected: null,
			returnSelected: null,


			policy_fulfillment: [],
			policy_payment: [],
			policy_return: [],

			items: [],
			itemsSelected: [],
			limit_per_page: 50,
			total_items: 0,
			current_page: 1,

			error: false,
			success: false,
			warning: false,

			modal: {
				title: false,
				body: false
			}
		};

		this.sku = React.createRef()
		this.startAt = React.createRef()
		this.qtyPerPage = React.createRef()
		this.selectCheck = React.createRef()
		this.mainCheckbox = React.createRef()
		this.operatorQtyOnHand = React.createRef()
		this.qtyOnHand = React.createRef()

		// Bind Allow access by "this" into the function
		this.fetchItems = this.fetchItems.bind(this);
		this.updateItem = this.updateItem.bind(this);
		this.updatePolicies = this.updatePolicies.bind(this);
		this.clearResult = this.clearResult.bind(this);
		this.selectListAction = this.selectListAction.bind(this);
		this.updatePage = this.updatePage.bind(this);
		this.selectItems = this.selectItems.bind(this);
		this.modal = this.modal.bind(this);
		//console.warn(this.props.getLevel());
		//console.warn(this.props.getUser());		
	}

	/* componentWillMount() {
		this.initialState = this.state
	} */

	componentDidUpdate(prevProps){
	}

	componentDidMount() {
		if(!this.props.securityClearance(this.props))	return "";
		this.initialLoading()
	}

	initialLoading() {
		this.updatePolicies();
		this.updateItem();
	}

	updateItem(e){
		if(e)	e.preventDefault();
		this.fetchItems((r) => {
			if(r.success){
				this.setState({"items": r.data, "total_items": r.nbr_items_total})
			}else if(r.error)
				this.props.info({"error": r.error})
			this.props.loading(false);
		});
	}

	fetchItems(callback, overwrite) {
		
		this.props.loading(true)
		if(typeof overwrite == "undefined")		overwrite = {}
		ajaxPerso( {
			"api": "eio",
			"trigger": "EbayGetItems",
			"policies": {
				"shipping": this.state.shippingSelected? this.state.shippingSelected.id_in_store : null,
				"payment": this.state.payementSelected? this.state.payementSelected.id_in_store : null,
				"return": this.state.returnSelected? this.state.returnSelected.id_in_store : null
			},
			"sku": this.sku.current.value,
			"current_page": "page" in overwrite? overwrite.page : this.state.current_page,
			// "limit_per_page": "qtyPerPage" in overwrite? overwrite.qtyPerPage : (this.qtyPerPage.current.value || this.state.limit_per_page),
			"limit_per_page": 50,
			"ship_start": this.startAt.current.value,
			"return_all": "returnAll" in overwrite? overwrite.returnAll : false,
			"qty_on_hand": this.qtyOnHand.current.value,
			"operator_qty": this.operatorQtyOnHand.current.value
		}, callback);
	}

	updatePolicies() {
		ajaxPerso( {
			"api": "eio",
			"trigger": "getPolicies"
		}, (r) => {
			if(r.success){
				this.setState({"policy_fulfillment": r.data.shipping, "policy_payment": r.data.payment, "policy_return": r.data.return})
			}else if(r.error)
				this.props.info({"error": r.error})
		});
	}

	clearResult() {
		this.setState(this.initialState, () => {
			this.props.info({"success": "UI reinitialized with success."})
		})
	}

	clearMsg() {
		this.setState({"error": false, "warning": false, "success": false})
	}

	selectListAction(e, typeName, objSelected) {
		e.preventDefault()
		let obj = {};
		
		obj[typeName] = objSelected;
		this.setState(obj)
	}

	updatePage(e, newPageNumber) {
		e.preventDefault()
		if(!newPageNumber)
			console.warn('Please indicate a page number positive.');
		this.setState({"current_page": newPageNumber}, () => {
			this.updateItem();
		})
	}

	selectItems(e, isFullSelect) {
		let itemId = e.target.value,
			itemsSel = [],
			items = this.state.items
		
		if(typeof isFullSelect == "undefined"){
			itemsSel = this.state.itemsSelected
			if(itemsSel.indexOf(itemId) >= 0)
				itemsSel.splice(itemsSel.indexOf(itemId), 1)
			else
				itemsSel.push(itemId)
			this.setState({"itemsSelected": itemsSel})
		}else if(e.target.checked){

			this.props.modal({
				show: true,
				title: "Confirmation",
				html: () => {
					return "Would you like to select all pages ? [" + this.state.total_items + " results]"
				},
				"ok": {
					title: "Accepte",
					fnc: () => {
						this.fetchItems((r) => {
							if(r.success){
								itemsSel = r.data.map((obj) => {
									return obj.id_item
								})
								this.setState({"itemsSelected": itemsSel})
							}
						}, {returnAll: true});
						$('#mainModal').modal('hide')
					}
				},
				"return": {
					title: "Refuse",
					fnc: () => {
						itemsSel = items.map((obj) => {
							return obj.id_item
						})
						this.setState({"itemsSelected": itemsSel})
					}
				},
				"exit": () => {
					this.mainCheckbox.current.checked = false
				}
			})
		}else
			this.setState({"itemsSelected": itemsSel})
	}

	modal(modalObj, obj) {
		if(typeof obj === "object"){
			if("yes" in obj && typeof obj.yes === "object"){
				this.fncModalAccept = obj.yes
			}
			if("no" in obj && typeof obj.no === "object"){
				this.fncModalRefuse = obj.no
			}
			if("exit" in obj && typeof obj.exit === "function"){
				this.fncModalExit = obj.exit
			}
		}

		this.setState({"modal": modalObj}, () => {
			$('#mainModal').modal('show')
		})
	}


	changePolicyModal(e, type) {
		var idPolicySelected = false;
		
		switch (type) {
		case "shipping":
			this.props.modal({
				show: true,
				title: "Policy change",
				html: () => {
					return <div className="">
						<div className="list-group limitSize">
							{this.state.policy_fulfillment.map((obj) => {
								return <span key={"shipping_int_"+obj.id_in_store} className={(parseInt(idPolicySelected) === parseInt(obj.id_in_store)? "active " : " ") + "list-group-item list-group-item-action text-left font-weight-normal listShipping1"} href={null} onClick={(e) => { e.preventDefault(); this.policyShippingIdModal = obj.id_in_store; $(".listShipping1").removeClass("active text-light"); $(e.target).toggleClass("active text-light"); }} >{obj.name} <span className="badge badge-primary badge-pill float-right">{obj.nbr_items}</span></span>
							})}
						</div>
					</div>
				},
				"ok": {
					title: "Validating",
					fnc: (popup, close) => {
						this.changePolicy(e, "shipping", this.policySelectedModal, (r) => {
							this.props.info(r)
							if(r.success){
								this.mainCheckbox.current.checked = false
								close()
							}
						})
					}
				}, "return": {
					title: "Return"
				}, "exit": () => {
					this.mainCheckbox.current.checked = false
				}
			})
			break;
		default:

			break;
		}
	}

	endItemList(e) {
		var self = this;
		if(this.state.itemsSelected.length === 0){
			this.props.info({error: 'Please select some items'})
		}else if(this.state.itemsSelected.length > 100){
			this.props.info({error: 'Deletion limited for your security.'})
		}else
			this.props.modal({
				show: true,
				title: "Confirmation",
				html: () => {
					return <div>
						Are you sure you want to delete all selected items counted: <span className="font-weight-bold">{this.state.itemsSelected.length}</span>
					</div>
				}
				,ok: {
					title: "I'm sure",
					fnc: (popup, close) => {
						
						ajaxPerso( {
							"api": `ebay`,
							"idItemList": this.state.itemsSelected.join(','),
							"trigger": "endListing"
						}, (r) => {
							console.info('Execute delTemplate:', r);
							let info = {error: false, success: false}
							close()
							
							info.success = r.success.length > 0? r.success.join(', ') : false
							info.error = r.error.length > 0? JSON.stringify(r.error) : false

							console.warn('info', info);
							
							self.props.info(info)
							this.initialLoading()
						})
					}
				},
				return: {
					title: "Close"
				}
			})
	}


	changePolicy(e, type, idPolicy, callback) {
		let level = this.props.getLevel()

		if(['admin', 'user'].indexOf(level) === -1)
			this.props.info({"error": "You don't have the autorisation to execute this query."})
		else{
			switch (type) {
			case "shipping":
				ajaxPerso( {
					"api": "ebay",
					"trigger": "revisePolicies",
					"policies": {
						'shipping': this.policyShippingIdModal,
						'payement': this.policyPayementgIdModal,
						'return': this.policyReturnIdModal
					},
					"itemId": this.state.itemsSelected,
					"shop": refConst.id_store_eBay_EIO
				}, callback);
				break;
			default:
				break;
			}
		}
	}

	render() {
		if(!this.props.securityClearance(this.props))	return "";

		return (
			<div className="main ctnPage">
				<div className="page-header ml-2 mb-3 d-flex flex-row">
					<img src="https://firebasestorage.googleapis.com/v0/b/ebayapp-85a68.appspot.com/o/eBay%2Febay-logo-right-now-medium.png?alt=media" width="108px" height="55px" alt="ebay logo"></img>
					<span className="ml-3 d-flex flex-column">
						<a href="https://www.ebay.com/help/policies/default/ebays-rules-policies?id=4205" target="_blank"  rel="noopener noreferrer">eBay rules and policies</a>
						<a href="https://www.ebay.com/help/policies/member-behaviour-policies/user-agreement?id=4259" target="_blank" rel="noopener noreferrer">eBay site policies</a>
					</span>
				</div>
				
				<Filter 
					vari={this.state}
					onSelectListAction={this.selectListAction}
					onClearResult={this.clearResult}
					onUpdateItem={this.updateItem}
					sku={this.sku}
					qtyPerPage={this.qtyPerPage}
					startAt={this.startAt}
					operatorQtyOnHand={this.operatorQtyOnHand}
					qtyOnHand={this.qtyOnHand}
				/>
				<div className={this.state.items.length? "" : "d-none"}>
					<div className={(this.state.avg? "" : "d-none") + " text-center text-white mx-auto p-2 h2 bg-primary"}>Average: {parseFloat(this.state.avg).toFixed(3)}</div>
					<div className="p-3 d-flex flex-row align-items-center">
						<span className="font-weight-bold">Shown page n°{this.state.current_page} <u>{this.state.items.length < this.state.limit_per_page? this.state.items.length : this.state.limit_per_page} of {this.state.total_items}</u></span>
						<div className="d-flex flex-row align-items-center ml-5">
							<span className="font-weight-bold">Selected {this.state.itemsSelected.length}</span>
							<div className="dropdown ml-2">
								<button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									Action
								</button>
								<div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
									<div className="dropdown-item position-relative overAndShow" href={null}>
										Change policies
										<FontAwesomeIcon icon={faCaretRight} className="ml-3"/>
										<div className="position-absolute subDropDownRightSide d-none">
											<div className="position-fixed dropdown-item bg-white border p-0">
												<ul className="list-group list-group-flush p-0 m-0">
													<div className="list-group-item list-group-item-action p-2 text-center" onClick={(e) => this.changePolicyModal(e, 'shipping')}>Shipping policy</div>
												</ul>
											</div>
										</div>
										
									</div>
									{
										this.props.getLevel() === 'admin'? <div className="dropdown-item position-relative overAndShow" href={null}  onClick={(e) => this.endItemList(e)}>
											End Items
										</div> : false
									}
								</div>
							</div>
						</div>
					</div>
					<ItemsTable 
						items={this.state.items}
						itemsSelected={this.state.itemsSelected}
						onSelectItems={this.selectItems}
						mainCheckbox={this.mainCheckbox}
					/>
					<Pagination 
						current_page={this.state.current_page}
						total_items={this.state.total_items}
						qtyPerPage={this.qtyPerPage}
						onUpdatePage={this.updatePage}
					/>
				</div>
				<Modal
					modal={this.state.modal}
					fncModalExit={this.fncModalExit}
					fncModalRefuse={this.fncModalRefuse}
					fncModalAccept={this.fncModalAccept}
				/>
			</div>
		);
	}
}

export default Ebay;
